<template>
  <slot />
</template>
<script setup lang="ts">
import { provideBugReportDialogContext } from "./utils";

const open = ref(false);
provideBugReportDialogContext({ open });
</script>
